"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_document_image_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../../main");
const document_1 = require("../../document");
const update_document_1 = require("../../../../../api/calls/document/update-document");
const document_overview_thunk_1 = require("../document_overview_thunk");
const upload_file_1 = require("../../../../../api/calls/upload_file");
exports.update_document_image_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/update_document_image_thunk", (arg, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { data, callback } = arg;
    const file = (_a = data.payload) === null || _a === void 0 ? void 0 : _a.file;
    if (!file)
        return;
    delete data.payload.file;
    dispatch((0, document_1.setIsLoading)(true));
    let screenshot = null;
    const uploadResponse = yield (0, upload_file_1.upload_file)({
        file: file,
        file_name: `document_${data.payload.page}.png`,
        description: "Document screenshot",
        type: "IMAGE",
        category: "DOCUMENT",
    }, false);
    if (uploadResponse.success) {
        screenshot = uploadResponse.content.location;
    }
    const response = yield (0, update_document_1.update_document)(Object.assign(Object.assign({}, data), (screenshot && { image: screenshot })), false);
    dispatch((0, document_1.setIsLoading)(false));
    if (response.success) {
        dispatch((0, main_1.setContentModal)(null));
        dispatch((0, document_1.editDocument)(response.content.document));
        dispatch((0, document_1.setSelectedDocument)(response.content.document));
        if ((_b = data.payload) === null || _b === void 0 ? void 0 : _b.status) {
            dispatch((0, document_overview_thunk_1.document_overview_thunk)());
        }
        if (callback)
            callback(response.content.document);
        return response.content;
    }
    else {
        // dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.message] }));
    }
    return null;
}));
